import GenericTableResponse from "@/models/api/GenericTableResponse";
import { CONTRACT_COMPONENT_TYPE_ENUM } from "@/static/contractComponentTypes";
import { Expose, Type } from "class-transformer";
import { IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class ContractComponent {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsString()
  @IsOptional()
  @Expose()
  fileId!: string | null;
  @IsString()
  @IsOptional()
  @Expose()
  fileName!: string | null;
  @IsEnum(CONTRACT_COMPONENT_TYPE_ENUM)
  @Expose()
  type!: string;
  @IsString()
  @Expose()
  description!: string;
}

export class ContractComponentResponse extends GenericTableResponse<ContractComponent> {
  @Type(() => ContractComponent)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ContractComponent>;
}
